var map = {
	"./arrows/default": 55,
	"./arrows/default.svg": 55,
	"./arrows/down": 56,
	"./arrows/down-short": 57,
	"./arrows/down-short.svg": 57,
	"./arrows/down.svg": 56,
	"./arrows/long": 58,
	"./arrows/long-white": 59,
	"./arrows/long-white.svg": 59,
	"./arrows/long.svg": 58,
	"./arrows/right": 60,
	"./arrows/right.svg": 60,
	"./arrows/tail-spin": 61,
	"./arrows/tail-spin.svg": 61,
	"./bg/flag": 62,
	"./bg/flag.png": 62,
	"./bg/group-course": 63,
	"./bg/group-course-wave": 64,
	"./bg/group-course-wave-pink": 65,
	"./bg/group-course-wave-pink.svg": 65,
	"./bg/group-course-wave.svg": 64,
	"./bg/group-course.svg": 63,
	"./bg/headers/bamboo-forest-left": 66,
	"./bg/headers/bamboo-forest-left.png": 66,
	"./bg/headers/bamboo-forest-right": 67,
	"./bg/headers/bamboo-forest-right.png": 67,
	"./bg/headers/course": 68,
	"./bg/headers/course.jpg": 68,
	"./bg/headers/geta": 69,
	"./bg/headers/geta.png": 69,
	"./bg/headers/gold-fish": 70,
	"./bg/headers/gold-fish.png": 70,
	"./bg/headers/meal": 71,
	"./bg/headers/meal.png": 71,
	"./bg/headers/origami": 72,
	"./bg/headers/origami.png": 72,
	"./bg/headers/pricing": 73,
	"./bg/headers/pricing.png": 73,
	"./bg/headers/registration": 74,
	"./bg/headers/registration.jpg": 74,
	"./bg/headers/sumo": 75,
	"./bg/headers/sumo.png": 75,
	"./bg/headers/test": 76,
	"./bg/headers/test.jpg": 76,
	"./bg/headers/testimonials": 77,
	"./bg/headers/testimonials.svg": 77,
	"./bg/headers/video-course": 78,
	"./bg/headers/video-course.svg": 78,
	"./bg/hero": 1,
	"./bg/hero.jpg": 355,
	"./bg/hero.svg": 1,
	"./bg/mosaic": 79,
	"./bg/mosaic.png": 79,
	"./bg/mosaic/ab1": 80,
	"./bg/mosaic/ab1.jpg": 80,
	"./bg/mosaic/ab2": 81,
	"./bg/mosaic/ab2.jpg": 81,
	"./bg/mosaic/brushes": 82,
	"./bg/mosaic/brushes.svg": 82,
	"./bg/mosaic/calligraphy": 83,
	"./bg/mosaic/calligraphy.jpg": 83,
	"./bg/mosaic/camp": 84,
	"./bg/mosaic/camp-2": 85,
	"./bg/mosaic/camp-2.jpg": 85,
	"./bg/mosaic/camp.jpg": 84,
	"./bg/mosaic/circle": 86,
	"./bg/mosaic/circle.svg": 86,
	"./bg/mosaic/cloud": 87,
	"./bg/mosaic/cloud-lightblue": 88,
	"./bg/mosaic/cloud-lightblue.svg": 88,
	"./bg/mosaic/cloud-red": 89,
	"./bg/mosaic/cloud-red.svg": 89,
	"./bg/mosaic/cloud.svg": 87,
	"./bg/mosaic/concert": 90,
	"./bg/mosaic/concert.jpg": 90,
	"./bg/mosaic/conversation": 91,
	"./bg/mosaic/conversation.svg": 91,
	"./bg/mosaic/dinner": 92,
	"./bg/mosaic/dinner.jpg": 92,
	"./bg/mosaic/doki-doki": 93,
	"./bg/mosaic/doki-doki.jpg": 93,
	"./bg/mosaic/drum": 94,
	"./bg/mosaic/drum.jpg": 94,
	"./bg/mosaic/hanami": 95,
	"./bg/mosaic/hanami.jpg": 95,
	"./bg/mosaic/hidden-message": 96,
	"./bg/mosaic/hidden-message.svg": 96,
	"./bg/mosaic/kimono": 97,
	"./bg/mosaic/kimono.svg": 97,
	"./bg/mosaic/koi": 98,
	"./bg/mosaic/koi.svg": 98,
	"./bg/mosaic/lector": 99,
	"./bg/mosaic/lector.jpg": 99,
	"./bg/mosaic/lesson": 100,
	"./bg/mosaic/lesson.jpg": 100,
	"./bg/mosaic/monika": 101,
	"./bg/mosaic/monika.jpg": 101,
	"./bg/mosaic/monitor": 102,
	"./bg/mosaic/monitor.svg": 102,
	"./bg/mosaic/ninja": 103,
	"./bg/mosaic/ninja.jpg": 103,
	"./bg/mosaic/origami": 104,
	"./bg/mosaic/origami-lightblue": 105,
	"./bg/mosaic/origami-lightblue.svg": 105,
	"./bg/mosaic/origami.svg": 104,
	"./bg/mosaic/oyakata": 106,
	"./bg/mosaic/oyakata.svg": 106,
	"./bg/mosaic/pattern-arrows": 107,
	"./bg/mosaic/pattern-arrows-light-blue": 108,
	"./bg/mosaic/pattern-arrows-light-blue.svg": 108,
	"./bg/mosaic/pattern-arrows-red": 109,
	"./bg/mosaic/pattern-arrows-red.svg": 109,
	"./bg/mosaic/pattern-arrows.svg": 107,
	"./bg/mosaic/pattern-circles": 110,
	"./bg/mosaic/pattern-circles-bigger": 111,
	"./bg/mosaic/pattern-circles-bigger.svg": 111,
	"./bg/mosaic/pattern-circles.svg": 110,
	"./bg/mosaic/pattern-daisy": 112,
	"./bg/mosaic/pattern-daisy-pink": 113,
	"./bg/mosaic/pattern-daisy-pink.svg": 113,
	"./bg/mosaic/pattern-daisy.svg": 112,
	"./bg/mosaic/pattern-flowers": 114,
	"./bg/mosaic/pattern-flowers.svg": 114,
	"./bg/mosaic/pattern-hexagon": 115,
	"./bg/mosaic/pattern-hexagon.svg": 115,
	"./bg/mosaic/pattern-hills": 116,
	"./bg/mosaic/pattern-hills.svg": 116,
	"./bg/mosaic/pattern-husk": 117,
	"./bg/mosaic/pattern-husk-blue": 118,
	"./bg/mosaic/pattern-husk-blue.svg": 118,
	"./bg/mosaic/pattern-husk-saphire": 119,
	"./bg/mosaic/pattern-husk-saphire.svg": 119,
	"./bg/mosaic/pattern-husk.svg": 117,
	"./bg/mosaic/pattern-triangles": 120,
	"./bg/mosaic/pattern-triangles-red": 121,
	"./bg/mosaic/pattern-triangles-red.svg": 121,
	"./bg/mosaic/pattern-triangles.svg": 120,
	"./bg/mosaic/pattern-wave": 122,
	"./bg/mosaic/pattern-wave.svg": 122,
	"./bg/mosaic/pattern-zigzag": 123,
	"./bg/mosaic/pattern-zigzag-light-blue": 124,
	"./bg/mosaic/pattern-zigzag-light-blue.svg": 124,
	"./bg/mosaic/pattern-zigzag.svg": 123,
	"./bg/mosaic/performance": 125,
	"./bg/mosaic/performance.jpg": 125,
	"./bg/mosaic/sakura": 126,
	"./bg/mosaic/sakura.svg": 126,
	"./bg/mosaic/sencha": 127,
	"./bg/mosaic/sencha.jpg": 127,
	"./bg/mosaic/shodo": 128,
	"./bg/mosaic/shodo-lesson": 129,
	"./bg/mosaic/shodo-lesson.jpg": 129,
	"./bg/mosaic/shodo.jpg": 128,
	"./bg/mosaic/sun": 130,
	"./bg/mosaic/sun.svg": 130,
	"./bg/mosaic/team": 131,
	"./bg/mosaic/team.jpg": 131,
	"./bg/mosaic/temple": 132,
	"./bg/mosaic/temple.svg": 132,
	"./bg/mosaic/workshops": 133,
	"./bg/mosaic/workshops.jpg": 133,
	"./bg/pattern": 134,
	"./bg/pattern.svg": 134,
	"./bg/patterns/activities/1": 135,
	"./bg/patterns/activities/1.svg": 135,
	"./bg/patterns/activities/2": 136,
	"./bg/patterns/activities/2.svg": 136,
	"./bg/patterns/activities/3": 137,
	"./bg/patterns/activities/3.svg": 137,
	"./bg/patterns/activities/4": 138,
	"./bg/patterns/activities/4.svg": 138,
	"./bg/patterns/activities/5": 139,
	"./bg/patterns/activities/5.svg": 139,
	"./bg/patterns/blog": 140,
	"./bg/patterns/blog.svg": 140,
	"./bg/patterns/chessboard": 141,
	"./bg/patterns/chessboard.svg": 141,
	"./bg/patterns/clouds": 142,
	"./bg/patterns/clouds.svg": 142,
	"./bg/patterns/ellipse": 143,
	"./bg/patterns/ellipse.svg": 143,
	"./bg/patterns/husk": 144,
	"./bg/patterns/husk.svg": 144,
	"./bg/patterns/materials": 145,
	"./bg/patterns/materials.svg": 145,
	"./bg/patterns/mosaic": 146,
	"./bg/patterns/mosaic.svg": 146,
	"./bg/patterns/pixels": 147,
	"./bg/patterns/pixels.svg": 147,
	"./bg/patterns/shape-blue": 148,
	"./bg/patterns/shape-blue.svg": 148,
	"./bg/patterns/squares": 149,
	"./bg/patterns/squares.svg": 149,
	"./bg/patterns/triangles": 150,
	"./bg/patterns/triangles-light": 151,
	"./bg/patterns/triangles-light.svg": 151,
	"./bg/patterns/triangles.svg": 150,
	"./bg/shapes/circle": 152,
	"./bg/shapes/circle.svg": 152,
	"./bg/shapes/cloud-1": 153,
	"./bg/shapes/cloud-1.svg": 153,
	"./bg/shapes/cloud-2": 154,
	"./bg/shapes/cloud-2.svg": 154,
	"./bg/shapes/cloud-blue": 155,
	"./bg/shapes/cloud-blue.svg": 155,
	"./bg/shapes/cloud-lightblue": 156,
	"./bg/shapes/cloud-lightblue.svg": 156,
	"./bg/shapes/cloud-red": 157,
	"./bg/shapes/cloud-red.svg": 157,
	"./bg/shapes/cube": 158,
	"./bg/shapes/cube.svg": 158,
	"./bg/shapes/ecru/1": 159,
	"./bg/shapes/ecru/1.svg": 159,
	"./bg/shapes/ecru/2": 160,
	"./bg/shapes/ecru/2.svg": 160,
	"./bg/shapes/ecru/3": 161,
	"./bg/shapes/ecru/3.svg": 161,
	"./bg/shapes/ecru/4": 162,
	"./bg/shapes/ecru/4.svg": 162,
	"./bg/shapes/gallery/activities": 163,
	"./bg/shapes/gallery/activities.svg": 163,
	"./bg/shapes/gallery/party": 164,
	"./bg/shapes/gallery/party.svg": 164,
	"./bg/shapes/gallery/trips": 165,
	"./bg/shapes/gallery/trips.svg": 165,
	"./bg/shapes/husk": 166,
	"./bg/shapes/husk.svg": 166,
	"./bg/shapes/triangles": 167,
	"./bg/shapes/triangles.svg": 167,
	"./icons/check": 168,
	"./icons/check-green": 169,
	"./icons/check-green.svg": 169,
	"./icons/check-light": 170,
	"./icons/check-light.svg": 170,
	"./icons/check-white": 171,
	"./icons/check-white.svg": 171,
	"./icons/check.svg": 168,
	"./icons/close": 172,
	"./icons/close.svg": 172,
	"./icons/cookies": 173,
	"./icons/cookies.svg": 173,
	"./icons/cross": 174,
	"./icons/cross.svg": 174,
	"./icons/dot": 175,
	"./icons/dot.svg": 175,
	"./icons/enroll": 176,
	"./icons/enroll.svg": 176,
	"./icons/envelope": 177,
	"./icons/envelope.svg": 177,
	"./icons/facebook": 178,
	"./icons/facebook-w": 179,
	"./icons/facebook-w.svg": 179,
	"./icons/facebook.svg": 178,
	"./icons/fb": 180,
	"./icons/fb.svg": 180,
	"./icons/flag-en": 181,
	"./icons/flag-en.svg": 181,
	"./icons/flag-jp": 182,
	"./icons/flag-jp.svg": 182,
	"./icons/flag-pl": 183,
	"./icons/flag-pl.svg": 183,
	"./icons/gift": 184,
	"./icons/gift.svg": 184,
	"./icons/instagram": 185,
	"./icons/instagram-w": 186,
	"./icons/instagram-w.svg": 186,
	"./icons/instagram.svg": 185,
	"./icons/keyboard": 187,
	"./icons/keyboard.svg": 187,
	"./icons/linkedin": 188,
	"./icons/linkedin.svg": 188,
	"./icons/marker": 2,
	"./icons/marker.png": 2,
	"./icons/marker.svg": 356,
	"./icons/mobile": 189,
	"./icons/mobile.svg": 189,
	"./icons/price": 190,
	"./icons/price-blue": 191,
	"./icons/price-blue.svg": 191,
	"./icons/price-green": 192,
	"./icons/price-green.svg": 192,
	"./icons/price-pink": 193,
	"./icons/price-pink.svg": 193,
	"./icons/price.svg": 190,
	"./icons/quote": 194,
	"./icons/quote-big": 195,
	"./icons/quote-big.svg": 195,
	"./icons/quote.svg": 194,
	"./icons/star-1-blue": 196,
	"./icons/star-1-blue.svg": 196,
	"./icons/star-1-red": 197,
	"./icons/star-1-red.svg": 197,
	"./icons/star-3-blue": 198,
	"./icons/star-3-blue.svg": 198,
	"./icons/star-3-red": 199,
	"./icons/star-3-red.svg": 199,
	"./icons/tag-blue": 200,
	"./icons/tag-blue.svg": 200,
	"./icons/tag-red": 201,
	"./icons/tag-red.svg": 201,
	"./icons/twitter": 202,
	"./icons/twitter.svg": 202,
	"./icons/youtube": 203,
	"./icons/youtube.svg": 203,
	"./icons/zoom": 204,
	"./icons/zoom.svg": 204,
	"./logo": 205,
	"./logo-mobile": 206,
	"./logo-mobile.svg": 206,
	"./logo.svg": 205,
	"./media/images/pic/teachers/anna-sielawko": 3,
	"./media/images/pic/teachers/anna-sielawko.png": 3,
	"./media/images/pic/teachers/anna-sielawko.webp": 357,
	"./media/images/pic/teachers/joanna-shimada": 4,
	"./media/images/pic/teachers/joanna-shimada.png": 4,
	"./media/images/pic/teachers/joanna-shimada.webp": 358,
	"./media/images/pic/teachers/kaede-funakoshi": 5,
	"./media/images/pic/teachers/kaede-funakoshi.png": 5,
	"./media/images/pic/teachers/kaede-funakoshi.webp": 359,
	"./media/images/pic/teachers/krzysztof-walaszek": 6,
	"./media/images/pic/teachers/krzysztof-walaszek.png": 6,
	"./media/images/pic/teachers/krzysztof-walaszek.webp": 360,
	"./media/images/pic/teachers/magdalena-kisly": 7,
	"./media/images/pic/teachers/magdalena-kisly.png": 7,
	"./media/images/pic/teachers/magdalena-kisly.webp": 361,
	"./media/images/pic/teachers/wiktoria-piontek": 8,
	"./media/images/pic/teachers/wiktoria-piontek.png": 8,
	"./media/images/pic/teachers/wiktoria-piontek.webp": 362,
	"./pic/activities/sakaki": 207,
	"./pic/activities/sakaki.png": 207,
	"./pic/activities/shizuoka": 208,
	"./pic/activities/shizuoka.png": 208,
	"./pic/activities/tokio": 209,
	"./pic/activities/tokio.png": 209,
	"./pic/advantage": 210,
	"./pic/advantage-mobile": 211,
	"./pic/advantage-mobile.png": 211,
	"./pic/advantage.png": 210,
	"./pic/authors/agata-krukowska": 212,
	"./pic/authors/agata-krukowska.png": 212,
	"./pic/authors/marta-klimiuk": 213,
	"./pic/authors/marta-klimiuk.png": 213,
	"./pic/authors/monika-zachaj": 214,
	"./pic/authors/monika-zachaj.png": 214,
	"./pic/blank/226x183": 215,
	"./pic/blank/226x183.jpg": 215,
	"./pic/bunkasai": 216,
	"./pic/bunkasai.jpg": 216,
	"./pic/compare/after": 217,
	"./pic/compare/after.jpg": 217,
	"./pic/compare/before": 218,
	"./pic/compare/before.jpg": 218,
	"./pic/compare/old/after": 219,
	"./pic/compare/old/after.jpg": 219,
	"./pic/compare/old/before": 220,
	"./pic/compare/old/before.jpg": 220,
	"./pic/contact": 221,
	"./pic/contact.svg": 221,
	"./pic/courses/00": 222,
	"./pic/courses/00.svg": 222,
	"./pic/courses/01": 223,
	"./pic/courses/01.svg": 223,
	"./pic/courses/02": 224,
	"./pic/courses/02.svg": 224,
	"./pic/courses/advanced-level": 225,
	"./pic/courses/advanced-level.png": 225,
	"./pic/courses/beginner-level": 226,
	"./pic/courses/beginner-level.png": 226,
	"./pic/courses/benefit01": 227,
	"./pic/courses/benefit01.svg": 227,
	"./pic/courses/benefit02": 228,
	"./pic/courses/benefit02.svg": 228,
	"./pic/courses/benefit03": 229,
	"./pic/courses/benefit03.svg": 229,
	"./pic/courses/benefit04": 230,
	"./pic/courses/benefit04.svg": 230,
	"./pic/courses/benefit05": 231,
	"./pic/courses/benefit05.svg": 231,
	"./pic/courses/benefit06": 232,
	"./pic/courses/benefit06.svg": 232,
	"./pic/courses/benefit07": 233,
	"./pic/courses/benefit07.svg": 233,
	"./pic/courses/benefit08": 234,
	"./pic/courses/benefit08.svg": 234,
	"./pic/courses/group-banner": 9,
	"./pic/courses/group-banner.png": 9,
	"./pic/courses/group-banner.webp": 363,
	"./pic/courses/group-teacher-left": 235,
	"./pic/courses/group-teacher-left.png": 235,
	"./pic/courses/group-teacher-right": 236,
	"./pic/courses/group-teacher-right.png": 236,
	"./pic/courses/intensity-beginner": 237,
	"./pic/courses/intensity-beginner.svg": 237,
	"./pic/courses/intensity-intensive": 238,
	"./pic/courses/intensity-intensive.svg": 238,
	"./pic/courses/intensity-standard": 239,
	"./pic/courses/intensity-standard.svg": 239,
	"./pic/courses/intermediate-level": 240,
	"./pic/courses/intermediate-level.png": 240,
	"./pic/courses/monika-zachaj": 241,
	"./pic/courses/monika-zachaj.png": 241,
	"./pic/courses/pakiet-startowy": 242,
	"./pic/courses/pakiet-startowy.png": 242,
	"./pic/courses/ryotaro-sakamoto": 243,
	"./pic/courses/ryotaro-sakamoto.png": 243,
	"./pic/courses/ryotaro-sakamoto2": 244,
	"./pic/courses/ryotaro-sakamoto2.png": 244,
	"./pic/courses/sun": 245,
	"./pic/courses/sun.svg": 245,
	"./pic/courses/zestaw-powitalny-gratis": 246,
	"./pic/courses/zestaw-powitalny-gratis.png": 246,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii": 247,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii.jpg": 247,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii": 248,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii.jpg": 248,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii": 249,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii.jpg": 249,
	"./pic/gallery/2018/szkola-letnia": 250,
	"./pic/gallery/2018/szkola-letnia.jpg": 250,
	"./pic/gallery/2018/warsztaty-chust-furoshiki": 251,
	"./pic/gallery/2018/warsztaty-chust-furoshiki.jpg": 251,
	"./pic/gallery/2018/warsztaty-ehomaki": 252,
	"./pic/gallery/2018/warsztaty-ehomaki.jpg": 252,
	"./pic/gallery/2018/warsztaty-herbaty-sencha": 253,
	"./pic/gallery/2018/warsztaty-herbaty-sencha.jpg": 253,
	"./pic/gallery/2018/warsztaty-kawaii-sushi": 254,
	"./pic/gallery/2018/warsztaty-kawaii-sushi.jpg": 254,
	"./pic/gallery/2019/impreza-bonenkai": 255,
	"./pic/gallery/2019/impreza-bonenkai.jpg": 255,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii": 256,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii.jpg": 256,
	"./pic/gallery/2019/szkola-letnia": 257,
	"./pic/gallery/2019/szkola-letnia.jpg": 257,
	"./pic/gallery/2019/warsztaty-obento": 258,
	"./pic/gallery/2019/warsztaty-obento.jpg": 258,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi": 259,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi.jpg": 259,
	"./pic/gallery/2020/ceremonia-herbaty": 260,
	"./pic/gallery/2020/ceremonia-herbaty.jpg": 260,
	"./pic/godzilla": 0,
	"./pic/godzilla-mobile": 10,
	"./pic/godzilla-mobile.png": 10,
	"./pic/godzilla-mobile.webp": 364,
	"./pic/godzilla.png": 0,
	"./pic/godzilla.svg": 365,
	"./pic/godzilla.webp": 366,
	"./pic/godzilla/beast": 261,
	"./pic/godzilla/beast.png": 261,
	"./pic/godzilla/pattern": 262,
	"./pic/godzilla/pattern.svg": 262,
	"./pic/google-rating": 263,
	"./pic/google-rating.svg": 263,
	"./pic/hero/all": 264,
	"./pic/hero/all.png": 264,
	"./pic/hero/clouds": 11,
	"./pic/hero/clouds.png": 11,
	"./pic/hero/clouds.webp": 367,
	"./pic/hero/desc": 265,
	"./pic/hero/desc.svg": 265,
	"./pic/hero/land": 12,
	"./pic/hero/land.png": 12,
	"./pic/hero/land.webp": 368,
	"./pic/hero/mobile": 13,
	"./pic/hero/mobile.jpg": 13,
	"./pic/hero/mobile.webp": 369,
	"./pic/hero/mountain": 14,
	"./pic/hero/mountain.png": 14,
	"./pic/hero/mountain.webp": 370,
	"./pic/hero/sea": 15,
	"./pic/hero/sea.png": 15,
	"./pic/hero/sea.webp": 371,
	"./pic/hero/stats-wave": 16,
	"./pic/hero/stats-wave.png": 16,
	"./pic/hero/stats-wave.webp": 372,
	"./pic/hero/sun": 17,
	"./pic/hero/sun.png": 17,
	"./pic/hero/sun.webp": 373,
	"./pic/hero/trees": 18,
	"./pic/hero/trees.png": 18,
	"./pic/hero/trees.webp": 374,
	"./pic/hero/video-bottom": 266,
	"./pic/hero/video-bottom.svg": 266,
	"./pic/hero/video-top": 267,
	"./pic/hero/video-top.svg": 267,
	"./pic/hero/waves": 19,
	"./pic/hero/waves.png": 19,
	"./pic/hero/waves.webp": 375,
	"./pic/home/1": 268,
	"./pic/home/1.svg": 268,
	"./pic/home/all": 269,
	"./pic/home/all.png": 269,
	"./pic/home/book-waku-waku": 20,
	"./pic/home/book-waku-waku.png": 20,
	"./pic/home/book-waku-waku.webp": 376,
	"./pic/home/owners": 21,
	"./pic/home/owners.png": 21,
	"./pic/home/owners.svg": 377,
	"./pic/home/pride": 22,
	"./pic/home/pride-cloud": 270,
	"./pic/home/pride-cloud.svg": 270,
	"./pic/home/pride-pattern": 271,
	"./pic/home/pride-pattern.svg": 271,
	"./pic/home/pride.png": 22,
	"./pic/home/pride.webp": 378,
	"./pic/home/video-course-preview": 272,
	"./pic/home/video-course-preview.png": 272,
	"./pic/home/video-courses": 273,
	"./pic/home/video-courses.png": 273,
	"./pic/keyboard": 274,
	"./pic/keyboard.svg": 274,
	"./pic/kitty-group": 275,
	"./pic/kitty-group-light": 276,
	"./pic/kitty-group-light.png": 276,
	"./pic/kitty-group.png": 275,
	"./pic/kitty-individual": 277,
	"./pic/kitty-individual.png": 277,
	"./pic/labels/a1_1": 278,
	"./pic/labels/a1_1.png": 278,
	"./pic/labels/a1_1b": 279,
	"./pic/labels/a1_1b.png": 279,
	"./pic/labels/a1_2": 280,
	"./pic/labels/a1_2.png": 280,
	"./pic/labels/a1_2a": 281,
	"./pic/labels/a1_2a.png": 281,
	"./pic/labels/a2_1": 282,
	"./pic/labels/a2_1.png": 282,
	"./pic/labels/a2_1b": 283,
	"./pic/labels/a2_1b.png": 283,
	"./pic/labels/a2_2": 284,
	"./pic/labels/a2_2.png": 284,
	"./pic/labels/a2_2a": 285,
	"./pic/labels/a2_2a.png": 285,
	"./pic/labels/a2_2b": 286,
	"./pic/labels/a2_2b.png": 286,
	"./pic/labels/b1_1": 287,
	"./pic/labels/b1_1.png": 287,
	"./pic/labels/b1_1b": 288,
	"./pic/labels/b1_1b.png": 288,
	"./pic/labels/b1_2": 289,
	"./pic/labels/b1_2.png": 289,
	"./pic/labels/b2_1": 290,
	"./pic/labels/b2_1.png": 290,
	"./pic/labels/b2_2": 291,
	"./pic/labels/b2_2.png": 291,
	"./pic/labels/c1_1": 292,
	"./pic/labels/c1_1.png": 292,
	"./pic/labels/c1_2": 293,
	"./pic/labels/c1_2.png": 293,
	"./pic/labels/c2_2": 294,
	"./pic/labels/c2_2.png": 294,
	"./pic/labels/materials/doki-doki-1": 295,
	"./pic/labels/materials/doki-doki-1.jpg": 295,
	"./pic/labels/materials/doki-doki-2": 296,
	"./pic/labels/materials/doki-doki-2.jpg": 296,
	"./pic/labels/materials/doki-doki-3": 297,
	"./pic/labels/materials/doki-doki-3.jpg": 297,
	"./pic/labels/materials/pera-pera-1": 298,
	"./pic/labels/materials/pera-pera-1.jpg": 298,
	"./pic/labels/materials/pera-pera-2": 299,
	"./pic/labels/materials/pera-pera-2.jpg": 299,
	"./pic/labels/materials/pera-pera-3": 300,
	"./pic/labels/materials/pera-pera-3.jpg": 300,
	"./pic/labels/materials/waku-waku-1": 301,
	"./pic/labels/materials/waku-waku-1.jpg": 301,
	"./pic/labels/materials/waku-waku-2": 302,
	"./pic/labels/materials/waku-waku-2.jpg": 302,
	"./pic/labels/materials/waku-waku-3": 303,
	"./pic/labels/materials/waku-waku-3.jpg": 303,
	"./pic/magazine": 304,
	"./pic/magazine.png": 304,
	"./pic/materials/100-lecie-przyjazni": 305,
	"./pic/materials/100-lecie-przyjazni.png": 305,
	"./pic/materials/hiragana": 306,
	"./pic/materials/hiragana.png": 306,
	"./pic/materials/katakana": 307,
	"./pic/materials/katakana.png": 307,
	"./pic/news-main": 308,
	"./pic/news-main.jpg": 308,
	"./pic/newsletter": 23,
	"./pic/newsletter.png": 23,
	"./pic/newsletter.svg": 379,
	"./pic/owners": 24,
	"./pic/owners.png": 24,
	"./pic/owners.webp": 380,
	"./pic/popup/icon-book": 309,
	"./pic/popup/icon-book.png": 309,
	"./pic/popup/icon-flags": 310,
	"./pic/popup/icon-flags.png": 310,
	"./pic/popup/icon-group": 311,
	"./pic/popup/icon-group.png": 311,
	"./pic/popup/icon-video": 312,
	"./pic/popup/icon-video.png": 312,
	"./pic/popup/popup-desktop-bg": 313,
	"./pic/popup/popup-desktop-bg.png": 313,
	"./pic/popup/popup-desktop-final": 314,
	"./pic/popup/popup-desktop-final.jpg": 314,
	"./pic/popup/popup-desktop-icons": 315,
	"./pic/popup/popup-desktop-icons.png": 315,
	"./pic/popup/popup-mobile-bg": 316,
	"./pic/popup/popup-mobile-bg.jpg": 316,
	"./pic/popup/popup-mobile-icons": 317,
	"./pic/popup/popup-mobile-icons.jpg": 317,
	"./pic/ramen1": 25,
	"./pic/ramen1.png": 25,
	"./pic/ramen1.svg": 381,
	"./pic/teachers/agata-krukowska": 26,
	"./pic/teachers/agata-krukowska.png": 26,
	"./pic/teachers/agata-krukowska.webp": 382,
	"./pic/teachers/alicja-suska": 27,
	"./pic/teachers/alicja-suska.png": 27,
	"./pic/teachers/alicja-suska.webp": 383,
	"./pic/teachers/animation": 318,
	"./pic/teachers/animation-image": 319,
	"./pic/teachers/animation-image.jpg": 319,
	"./pic/teachers/animation.svg": 318,
	"./pic/teachers/anna-sielawko": 28,
	"./pic/teachers/anna-sielawko.png": 28,
	"./pic/teachers/anna-sielawko.webp": 384,
	"./pic/teachers/hiroko-fujii": 29,
	"./pic/teachers/hiroko-fujii.png": 29,
	"./pic/teachers/hiroko-fujii.webp": 385,
	"./pic/teachers/joanna-shimada": 30,
	"./pic/teachers/joanna-shimada.png": 30,
	"./pic/teachers/joanna-shimada.webp": 386,
	"./pic/teachers/julia-caba": 31,
	"./pic/teachers/julia-caba.png": 31,
	"./pic/teachers/julia-caba.webp": 387,
	"./pic/teachers/kaede-funakoshi": 32,
	"./pic/teachers/kaede-funakoshi.png": 32,
	"./pic/teachers/kaede-funakoshi.webp": 388,
	"./pic/teachers/katarzyna-stanko": 33,
	"./pic/teachers/katarzyna-stanko.png": 33,
	"./pic/teachers/katarzyna-stanko.webp": 389,
	"./pic/teachers/krzysztof-walaszek": 34,
	"./pic/teachers/krzysztof-walaszek.png": 34,
	"./pic/teachers/krzysztof-walaszek.webp": 390,
	"./pic/teachers/magdalena-kisly": 35,
	"./pic/teachers/magdalena-kisly.png": 35,
	"./pic/teachers/magdalena-kisly.webp": 391,
	"./pic/teachers/marin-iwai": 36,
	"./pic/teachers/marin-iwai.png": 36,
	"./pic/teachers/marin-iwai.webp": 392,
	"./pic/teachers/marta-klimiuk-nikkarinen": 37,
	"./pic/teachers/marta-klimiuk-nikkarinen.png": 37,
	"./pic/teachers/marta-klimiuk-nikkarinen.webp": 393,
	"./pic/teachers/marta-szulc": 38,
	"./pic/teachers/marta-szulc.png": 38,
	"./pic/teachers/marta-szulc.webp": 394,
	"./pic/teachers/miho-takahashi": 39,
	"./pic/teachers/miho-takahashi.png": 39,
	"./pic/teachers/miho-takahashi.webp": 395,
	"./pic/teachers/monika-zachaj": 40,
	"./pic/teachers/monika-zachaj.png": 40,
	"./pic/teachers/monika-zachaj.webp": 396,
	"./pic/teachers/owner": 320,
	"./pic/teachers/owner.png": 320,
	"./pic/teachers/ryotaro-sakamoto": 41,
	"./pic/teachers/ryotaro-sakamoto.png": 41,
	"./pic/teachers/ryotaro-sakamoto.webp": 397,
	"./pic/teachers/sayaka-nakai": 321,
	"./pic/teachers/sayaka-nakai.webp": 321,
	"./pic/teachers/urszula-hellich": 42,
	"./pic/teachers/urszula-hellich.png": 42,
	"./pic/teachers/urszula-hellich.webp": 398,
	"./pic/teachers/weronika-smorag": 43,
	"./pic/teachers/weronika-smorag.png": 43,
	"./pic/teachers/weronika-smorag.webp": 399,
	"./pic/teachers/wiktoria-piontek": 44,
	"./pic/teachers/wiktoria-piontek.png": 44,
	"./pic/teachers/wiktoria-piontek.webp": 400,
	"./pic/team": 322,
	"./pic/team.jpg": 322,
	"./pic/testimonials/awatar-01": 323,
	"./pic/testimonials/awatar-01.svg": 323,
	"./pic/testimonials/awatar-02": 324,
	"./pic/testimonials/awatar-02.svg": 324,
	"./pic/testimonials/awatar-03": 325,
	"./pic/testimonials/awatar-03.svg": 325,
	"./pic/testimonials/awatar-04": 326,
	"./pic/testimonials/awatar-04.svg": 326,
	"./pic/testimonials/awatar-05": 327,
	"./pic/testimonials/awatar-05.svg": 327,
	"./pic/testimonials/awatar-06": 328,
	"./pic/testimonials/awatar-06.svg": 328,
	"./pic/testimonials/awatar-07": 329,
	"./pic/testimonials/awatar-07.svg": 329,
	"./pic/testimonials/awatar-08": 330,
	"./pic/testimonials/awatar-08.svg": 330,
	"./pic/testimonials/awatar-09": 45,
	"./pic/testimonials/awatar-09.png": 45,
	"./pic/testimonials/awatar-09.svg": 401,
	"./pic/testimonials/awatar-10": 331,
	"./pic/testimonials/awatar-10.svg": 331,
	"./pic/testimonials/awatar-11": 332,
	"./pic/testimonials/awatar-11.svg": 332,
	"./pic/testimonials/awatar-12": 333,
	"./pic/testimonials/awatar-12.svg": 333,
	"./pic/testimonials/blank": 46,
	"./pic/testimonials/blank.jpg": 46,
	"./pic/testimonials/blank.webp": 402,
	"./pic/testimonials/gabrysia": 47,
	"./pic/testimonials/gabrysia.jpg": 47,
	"./pic/testimonials/gabrysia.webp": 403,
	"./pic/testimonials/klaudia": 48,
	"./pic/testimonials/klaudia.jpg": 48,
	"./pic/testimonials/klaudia.webp": 404,
	"./pic/testimonials/kuba": 49,
	"./pic/testimonials/kuba.jpg": 49,
	"./pic/testimonials/kuba.webp": 405,
	"./pic/testimonials/monika": 50,
	"./pic/testimonials/monika.jpg": 50,
	"./pic/testimonials/monika.webp": 406,
	"./pic/testimonials/naza": 51,
	"./pic/testimonials/naza.jpg": 51,
	"./pic/testimonials/naza.webp": 407,
	"./pic/testimonials/patti": 52,
	"./pic/testimonials/patti.jpg": 52,
	"./pic/testimonials/patti.webp": 408,
	"./pic/testimonials/wiktoria": 53,
	"./pic/testimonials/wiktoria.jpg": 53,
	"./pic/testimonials/wiktoria.webp": 409,
	"./pic/timeline": 334,
	"./pic/timeline.jpg": 334,
	"./pic/timeline/2011": 335,
	"./pic/timeline/2011.jpg": 335,
	"./pic/timeline/2013": 336,
	"./pic/timeline/2013.jpg": 336,
	"./pic/timeline/2014": 337,
	"./pic/timeline/2014.jpg": 337,
	"./pic/timeline/2016": 338,
	"./pic/timeline/2016.jpg": 338,
	"./pic/timeline/2017": 339,
	"./pic/timeline/2017.jpg": 339,
	"./pic/timeline/2018": 340,
	"./pic/timeline/2018.jpg": 340,
	"./pic/timeline/2019": 341,
	"./pic/timeline/2019.jpg": 341,
	"./pic/timeline/2020": 342,
	"./pic/timeline/2020.jpg": 342,
	"./pic/timeline/2021": 343,
	"./pic/timeline/2021.jpg": 343,
	"./pic/timeline/2022": 344,
	"./pic/timeline/2022.jpg": 344,
	"./pic/timeline/2023": 345,
	"./pic/timeline/2023.jpg": 345,
	"./pic/timeline/2024": 346,
	"./pic/timeline/2024.jpg": 346,
	"./pic/tree": 54,
	"./pic/tree.png": 54,
	"./pic/tree.webp": 410,
	"./pic/umbrella": 347,
	"./pic/umbrella.jpg": 347,
	"./pic/warsaw-card": 348,
	"./pic/warsaw-card.jpg": 348,
	"./pic/wave": 349,
	"./pic/wave.png": 349,
	"./pic/wsjj-team": 350,
	"./pic/wsjj-team-mobile": 351,
	"./pic/wsjj-team-mobile.webp": 351,
	"./pic/wsjj-team.webp": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;